import {
  CREATE_USER_APPOINTMENT,
    EDIT_USER_APPOINTMENT,
    USER_APPOINTMENT_LIST,
    USER_APPOINTMENT_LIST_FOR_ADMIN,
    USER_APPOINTMENT_STATUS_UPDATE
  } from "../types";
  
  const initialState = {
    response: null,
    loading: true,
    create: false,
    edit: false,
    update:false
  };
 
  
  export default function userAppointmentStore(state = initialState, action) {
    switch (action.type) {
      case USER_APPOINTMENT_LIST:
        return {
          ...state,
          create: false,
          edit: false,
          update:false,
          loading: false,
          response: action.payload,
        };
        case USER_APPOINTMENT_LIST_FOR_ADMIN:
        return {
          ...state,
          create: false,
          edit: false,
          update:false,
          loading: false,
          response: action.payload,
        };
        case USER_APPOINTMENT_STATUS_UPDATE:
        return {
          ...state,
          create: false,
          update: true,
          edit:false,
          response: action.payload,
        };
        case CREATE_USER_APPOINTMENT:
          return {
            ...state,
            create: true,
            edit: false,
            update:false,
            response: action.payload,
          };
          case EDIT_USER_APPOINTMENT:
          return {
            ...state,
            create: false,
            edit: true,
            update:false,
            response: action.payload,
          };
      default:
        return state;
    }
  }